/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Mild_Panda_CoilInputs */

const en_fresh_mild_panda_coil = /** @type {(inputs: Fresh_Mild_Panda_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_fresh_mild_panda_coil = /** @type {(inputs: Fresh_Mild_Panda_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Fresh_Mild_Panda_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_mild_panda_coil = /** @type {((inputs?: Fresh_Mild_Panda_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Mild_Panda_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_mild_panda_coil(inputs)
	return de_fresh_mild_panda_coil(inputs)
});